import { cloneElement } from "react";
import PropTypes from "prop-types";

import "./DirectionalIcon.css";

/**
 * DirectionalIcon flips the icon horizontally when the direction is RTL.
 */
export function DirectionalIcon({ children, className }) {
  if (!children) return null;

  // Add any className passed to either the DirectionalIcon or the child.
  const classNames = ["directional-icon", className, children.props.className]
    .filter(Boolean)
    .join(" ");

  // Clone the child element with classNames to avoid adding wrapper elements
  return cloneElement(children, {
    className: classNames,
  });
}

DirectionalIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
